import React from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Stack,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import Grid from "@mui/material/Grid2";

import PageBgBlock from "../GeneralComponents/PageBgBlock";
import PageButtonSimple from "../GeneralComponents/PageButtonSimple";

import { DEFAULT_ITEMS_CONTINGENCIAS } from "../../Constants/Constants";
import { parseBoldText } from "../utils/general_utils";




export default function ContingenciasSelection({
  items = DEFAULT_ITEMS_CONTINGENCIAS,
  onSelect,
  onOpenList,              
  showListLink = true,
}) {
  const navigate = useNavigate();
  return (
    <PageBgBlock pad="2rem 2rem">
        <Stack spacing={2} alignItems="center" sx={{ textAlign: "center" }}>
          <Typography
                  variant="h1"
                  align="center"
                  sx={{ marginBottom: "0.24rem" }}
                >
            CREACIÓN DE JUSTIFICACIÓN DE INDISPONIBILIDAD
          </Typography>

          <Typography variant="body1" sx={{ maxWidth: 900, color: "text.secondary", pb: 1 }}>
            Esta sección de creación de Justificación de Indisponibilidad  le permite reportar y justificar interrupciones o problemas de conectividad no atribuibles a su gestión. Seleccione la categoría de justificación de indisponibilidad que mejor describa la situación presentada.
          </Typography>

          <Grid container spacing={2} sx={{ mt: 1, width: "100%", maxWidth: 1200 }}>
            {items.map((card) => (
              <Grid key={card.id} size={{ xs: 12, md: 3 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2.5,
                    height: "100%",
                    borderRadius: 3,
                    background: "#BBDEFB",
                  }}
                >
                  <Stack spacing={1.5} sx={{ height: "100%" }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={900}
                      sx={{ letterSpacing: 0.4, textTransform: "uppercase", pb: 1 }}
                    >
                      {card.title}
                    </Typography>

                    <Typography variant="body2" sx={{ color: "text.secondary", flexGrow: 1, pb: 1}}>
                      {parseBoldText(card.description)}
                    </Typography>

                    <Box>
                      <PageButtonBlack
                        width="100%"
                        onClick={() =>
                          onSelect?.({
                            id: card.id,
                            type: card.type,
                            subtype: card.subtype,
                            title: card.title,
                            description: card.description,
                          })
                        }
                      >
                        {card.actionText ?? "Crear justificación de indisponibilidad"}
                      </PageButtonBlack>
                    </Box>
                  </Stack>
                </Paper>
              </Grid>
            ))}
          </Grid>

          {showListLink && (
            <>
              <Typography variant="body1" sx={{ color: "text.secondary", pt: 3  }}>
                Si quiere revisar el listado de Justificaciones de Indisponibilidad ya creadas puede ingresar a través del
                menú, ir a Justificaciones de Indisponibilidad y seleccionar ‘Ver listado’ o puede ingresar en el siguiente enlace
              </Typography>
              <PageButtonSimple onClick={() => navigate("/contingencias_lista")}>
                  Ir al listado de justificaciones de indisponibilidad
                </PageButtonSimple>
            </>
          )}
        </Stack>
    </PageBgBlock>
  );
}
